import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputField } from "../../../Components/formElements/InputField";
import FailureModal from "../../../Components/Modal/supplier_app/FailureModal";
import SupplierConstants from "../../../common/SupplierConstants";
import { useNavigate } from "react-router-dom";

const Partners360Modal = React.forwardRef(
  ({ partnerData, show, onHide, ...props }, ref) => {
    const [formData, setFormData] = useState({
      year: "",
      firstName: "",
      companyName: "",
      email: "",
    });
    const navigate = useNavigate();
    const [getShowFailureModal, setShowFailureModal] = useState(false);

    const handleChange = (e) => {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    };

    const handleSubmit = () => {
      navigate(SupplierConstants.PARTNERS_360_PAGE, {
        state: {
          partnerData,
          formData,
        },
      });

      onHide();
    };

    const hideFailureModal = () => {
      setShowFailureModal(false);
    };

    useEffect(() => {
      // Reset form when modal is closed
      if (!show) {
        setFormData({
          year: "",
          firstName: "",
          companyName: "",
          email: "",
        });
      }
    }, [show]);

    return (
      <Modal
        show={show}
        onHide={onHide}
        aria-labelledby="contained-modal-title-vcenter"
        keyboard={false}
        size="lg"
        ref={ref}
        centered
        {...props}
      >
        <Modal.Header closeButton>
          <Modal.Title>Partners 360 {partnerData?.userId || "--"}</Modal.Title>
        </Modal.Header>
        <Row>
          <Col xs={5} lg={2} className="me-2">
            <p className="bg-table-status bg-table-new-status mb-1 px-2 pt-2">
              {partnerData?.userId || "--"}
            </p>
          </Col>
        </Row>

        <Modal.Body>
          {/* Year */}
          <Row className="mb-3">
            <Col>
              <InputField
                className="inputBox"
                label="Year"
                name="year"
                id="year"
                placeholder="Enter Year"
                value={formData.year || ""}
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <button onClick={handleSubmit} className="btn btn-primary">
            Submit
          </button>

          <button onClick={onHide} className="btn btn-danger">
            Cancel
          </button>
        </Modal.Footer>

        <FailureModal
          show={getShowFailureModal}
          onHide={() => hideFailureModal()}
          // failuremodaldata={getFailureModal}
        />
      </Modal>
    );
  },
);

export default Partners360Modal;
